import React from "react";
import { Card, Typography } from "antd";

import { BiMap } from "react-icons/bi";
import { AiOutlineCalendar } from "react-icons/ai";
import { VscRss } from "react-icons/vsc";
import { BsPeople } from "react-icons/bs";
import { IoIosPeople } from "react-icons/io";

const { Title } = Typography;
const ProfileIntro = () => {
  return (
    <>
      <div className="ProfileIntro">
        <Card className="sidebarCard">
          <Title level={4}> Profile Intro</Title>
          <div className="flex items-center py-4">
            <BiMap
              style={{ fontSize: "20px", color: "#000", marginRight: "15px" }}
            />
            <p className="text-xl">Lagos Nigeria</p>
          </div>
          <div className="flex items-center py-4">
            <AiOutlineCalendar
              style={{ fontSize: "20px", color: "#000", marginRight: "15px" }}
            />
            <p className="text-xl">Joined August 2021</p>
          </div>
          <div className="flex items-center py-4">
            <VscRss
              style={{ fontSize: "20px", color: "#000", marginRight: "15px" }}
            />
            <p className="text-xl">21 Following</p>
          </div>
          <div className="flex items-center py-4">
            <IoIosPeople
              style={{ fontSize: "20px", color: "#000", marginRight: "15px" }}
            />
            <p className="text-xl">42 Followers</p>
          </div>
          <div className="flex items-center py-4">
            <BsPeople
              style={{ fontSize: "20px", color: "#000", marginRight: "15px" }}
            />
            <p className="text-xl">2 Forums Joined</p>
          </div>
        </Card>
      </div>
    </>
  );
};

export default ProfileIntro;
